/* ----- Path Replacement Logic ----- */
const pathReplacements = [
    { oldPath: "/index.php/", newPath: "https://pitboss-grills.com/" }
];

// Check the current page URL and replace paths
window.addEventListener('DOMContentLoaded', () => {
    let currentUrl = window.location.href;
    pathReplacements.forEach(({ oldPath, newPath }) => {
        if (currentUrl.includes(oldPath)) {
            const modifiedUrl = currentUrl.replace(oldPath, newPath);
            window.location.href = modifiedUrl; // Redirect to modified URL
        }
    });
});
